import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

export default function MarketplaceOverview() {
  const { t, isRTL } = useContext(LanguageContext);

  const benefits =
    t("marketplaceOverview.benefits", { returnObjects: true }) || [];
  const steps =
    t("marketplaceOverview.steps", { returnObjects: true }) || [];
  const paragraphs =
    t("marketplaceOverview.intro.paragraphs", { returnObjects: true }) || [];

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-gray-50 py-24">
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <div className="mx-auto mb-16 max-w-3xl text-center">
          <span className="inline-block rounded-full bg-rose-50 px-4 py-1 text-sm font-semibold text-rose-600">
            {t("marketplaceOverview.badge")}
          </span>

          <h2 className="mt-6 text-4xl font-bold text-gray-900">
            {t("marketplaceOverview.title")}
          </h2>

          <p className="mt-4 text-lg text-gray-600">
            {t("marketplaceOverview.subtitle")}
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid gap-12 lg:grid-cols-2">

          {/* Left Content */}
          <div>
            <h3 className="text-2xl font-semibold text-gray-900">
              {t("marketplaceOverview.intro.title")}
            </h3>

            {paragraphs.map((text, i) => (
              <p key={i} className="mt-4 text-gray-600 leading-relaxed">
                {text}
              </p>
            ))}

            <ul className="mt-6 space-y-3 text-gray-700">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-rose-500">✓</span>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>

          {/* Right Steps */}
          <div className="space-y-6">
            {steps.map((item, index) => (
              <div
                key={index}
                className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
              >
                <h4 className="font-semibold text-gray-900">
                  {index + 1}. {item.title}
                </h4>
                <p className="mt-2 text-gray-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>

        </div>

        {/* CTA */}
        <div className="mt-20 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <button className="rounded-xl bg-rose-600 px-8 py-4 font-semibold text-white hover:bg-rose-700">
            {t("marketplaceOverview.cta.merchant")}
          </button>

          <button className="rounded-xl border border-gray-300 px-8 py-4 font-semibold text-gray-900 hover:bg-gray-100">
            {t("marketplaceOverview.cta.partner")}
          </button>
        </div>
      </div>
    </section>
  );
}
